import ConversationAttachmentWellViewState from '../schema/ConversationAttachmentWellViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'setConversationAttachmentWellVisible',
    function setConversationAttachmentWellVisible(
        attachmentWell: ConversationAttachmentWellViewState,
        visible: boolean
    ) {
        attachmentWell.isVisible = visible;
    }
);
